module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/add-codeitem/add-codeitem.component.html
// module id = 1507
// module chunks = 2